module.exports = __webpack_public_path__ + "static/media/TJ.afbc3b3f.svg";